import { render, staticRenderFns } from "./component.vue?vue&type=template&id=01022ea2&scoped=true&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"
import style0 from "./component.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./component.vue?vue&type=style&index=1&id=01022ea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01022ea2",
  null
  
)

export default component.exports